import { useState } from 'react';
import { InvoiceStatusClient, InvoiceStatusDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useInvoiceStatusApi = () => {
    const apiClient = new InvoiceStatusClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: InvoiceStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createInvoiceStatus(data);
        } catch (err: any) {
            setError(err.message || 'Error creating InvoiceStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: InvoiceStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateInvoiceStatus(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating InvoiceStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getInvoiceStatusById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching InvoiceStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchInvoiceStatuses(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching InvoiceStatuses');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteInvoiceStatus(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting InvoiceStatus');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};